import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isLoaded as citiesLoaded, getCities } from './redux/modules/cities';
import DocumentMeta from 'react-document-meta';
import Header from './layout/header';
import Footer from './layout/footer';
import Testimonials from './common/testimonials';
import { setStatusCode, rotateAlerts } from './redux/modules/app';
import Alerts from './common/alerts';

import { i18nContext, onUndefined } from 'kodyl-js/i18n/react';
import ErrorBoundary from './common/ErrorBoundary';

if (__CLIENT__ && __DEV__) {
  onUndefined((str, lang) => {
    console.warn(`[kodyl-js/i18n]: ${lang} translation missing for: "${str}"`);
  });
}

if (__CLIENT__) {
  global.onerror = function(err) {
    if (__DEV__) {
      console.error(err);
    }
    if (err !== 'Script error.' || __DEV__) {
      const doc = global.document;
      let errMsg = '';
      try {
        errMsg = JSON.stringify(arguments);
      } catch (err) {
        errMsg = err.message;
      }
      const img = doc.createElement('img');
      img.src = '/i.gif?error=' + encodeURIComponent(errMsg);
      doc.getElementsByTagName('body')[0].appendChild(img);
    }
  };
}

class App extends Component {
  static fetchData({ getState, dispatch, params }) {
    return Promise.all([
      !citiesLoaded(getState()) && dispatch(getCities()),
      dispatch(rotateAlerts())
    ]).then(() => {
      if (params.city) {
        if (
          !getState().cities.list.filter(
            item => item.slug.indexOf(params.city) !== -1
          ).length
        ) {
          dispatch(setStatusCode(404));
        }
      }
    });
  }

  render() {
    const {
      children,
      alerts,
      canonical,
      search: { hero },
      location,
      ...props
    } = this.props;
    const inUserFlow = !/^\/(profile|signup|login)/.test(location.pathname);

    const docMeta = {
      title: 'Find din nye lejebolig på Boligninja.dk',
      description:
        'Boligninja.dk er Danmarks nyeste boligportal, hvor du finder tusindvis ledige lejligheder og huse til leje. Find din nye lejebolig eller lejelejlighed her.',
      canonical: canonical.path && `${canonical.host}${canonical.path}`,
      auto: {
        ograph: true
      }
    };

    return (
      <DocumentMeta {...docMeta} extend>
        <div className={hero ? null : 'page-listing'}>
          <Header showSearch={inUserFlow} narrow={location.pathname !== '/'} />
          <Alerts alerts={alerts} />
          <ErrorBoundary>
            {children ? React.cloneElement(children, { ...props }) : null}
          </ErrorBoundary>
        </div>
        <Testimonials />
        <Footer />
      </DocumentMeta>
    );
  }
}

export default connect(({ i18n, search, app: { canonical, alerts } }) => ({
  i18n,
  search,
  canonical,
  alerts
}))(i18nContext(App));
